<template>
  <div>
    
    <v-fab-transition>
      <v-btn
        v-if="mobile()"
        data-testid="navbar-mobile"
        color="white"
        elevation="2"
        fixed
        left
        fab
        top
       :class="{ 'trial-absolute-button': ((productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || subscriptionEnds || (productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))) && mobile(), 'mt-13' : !productPlan.attributes || (productPlan.attributes && productPlan.attributes.name != 'Pro Trial') && !subscriptionEnds && !(productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))}"

        style="z-index: 6"
        @click="updateDrawerState" 
      >
        <v-icon medium>
          mdi-menu
        </v-icon>
      </v-btn>
    </v-fab-transition>
    <v-navigation-drawer
      v-model="drawer"
      data-testid="navbar"
      class="navbar-left-global"
      clipped
      app
      :style="mobile() && ((productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || subscriptionEnds || (productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))) ? &quot;margin-top:88px;&quot; : mobile() ? &quot;margin-top:56px;&quot; :  &quot;&quot;"
      :height="mobile() && ((productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || subscriptionEnds  || (productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))) ? &quot;calc(100vh - 88px)&quot; : mobile() ? &quot;calc(100vh - 56px)&quot; :  &quot;100vh&quot;"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :width="250"
      hide-overlay
    >

      <v-list class="pa-4">
        <div style="position: relative;">
          <v-menu
            ref="menuRef"
            style="z-index: 99"
            offset-y
            right
            v-if="role != 'guest' && role != 'participant'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-fab-transition>
                
                <v-btn
                  data-testid="create-content-template"
                  class="ml-6 mb-4 align-self-end text-right rounded-xl elevation-0 text-caption"
                  color="disabled"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon medium>mdi-plus</v-icon> {{ $t('create') }}
                </v-btn>

              </v-fab-transition>
            </template>
            <v-list data-testid="menu-list">
              <v-list-item
                data-testid="create-activity-button"
                router 
                @click.stop="dialogVisibleCreateActivity=true"
              >
                <v-list-item-title> {{ $t('createActivity') }}</v-list-item-title>
              </v-list-item>
              
              <v-list-item
                data-testid="create-hub-button"
                router 
                @click.stop="createHub"
                :disabled="productPlan.attributes && productPlan.attributes.name === 'Free'" 
              >
                <v-list-item-title> {{ $t('createHub') }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="(role == 'booster' || role == 'space_admin') 
                  && productPlan.attributes 
                  && productPlan.attributes.workflow_module == 1
                "
                data-testid="create-workflow-button"
                router 
                @click.stop="dialogVisibleSelectWorkflowType = true,
                action = 'createWorkflowType',
                confirmationDialogTitleWithInputField = $t('confirmationDialogTitleCreateWorkflow'),
                confirmationDialogTextWithInputField = $t('confirmationDialogTextCreateWorkflow'),
                confirmationDialogInputPlaceholder = $t('confirmationDialogInputPlaceholderCreateWorkflow'),
                confirmationDialogWithInputFieldSubmitBtn = $t('create')
                confirmationDialogWithInputFieldCancelBtn = $t('cancel')"
              >
                <v-list-item-title> {{ $t('createWorkflow') }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                data-testid="create-user-button"
                router 
                @click.stop="createUser"
              >
                <v-list-item-title> {{ $t('createUser') }}</v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>
          <!-- <v-subheader class="text-h5 font-weight-bold px-4 darktext--text">
            {{ $t('viewsNavigationHeader') }}
          </v-subheader> -->
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            v-if="mobile()"
            color="greytext--text"
            top
            right
            icon
            absolute
            class="mt-n3"
            @click="drawer=false"
          >
            <v-icon
              color="black"
            >
              mdi-backburger
            </v-icon>
          </v-btn>
        </div>

        <!-- <v-divider /> -->
        <v-list class="py-0">
          <v-list-item
            router
            to="/dashboard"
            :class="{'v-list-item--active': (($route.name ==='Dashboard') || ($route.name === 'MyWorkflows') || ($route.name === 'AllActivities') || ($route.name === 'AllHubs') || ($route.name === 'AllCertificates')) }"
            class="menu_text pl-8 pr-0 home-menu-item"
          >
          
            <v-list-item-title><v-icon size="16" class="mr-2" :color="$route.name === 'Dashboard' || $route.name === 'MyWorkflows' || $route.name === 'AllActivities' || $route.name === 'AllHubs' || $route.name === 'AllCertificates' ? 'inherit' : 'darktext'" style="margin-bottom: 3px">mdi-home-variant</v-icon>   {{ $t('home') }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list 
          class="py-0"
          v-if="role == 'space_admin' &&  productPlan.attributes && productPlan.attributes.name !== 'Free'"
        >
          <!-- <v-list-item
            v-for="menu_item in menu_items_activities"
            :key="menu_item.text"
            router
            :to="menu_item.route"
            class="menu_text pl-8 pr-0"
            :class="{'v-list-item--active': (menu_item.text == 'createdByMe' && menu_item.icon_menu == 'mdi-auto-fix' && ($route.fullPath ==='/hubs' || $route.fullPath === '/activities' )) || (menu_item.text == 'sharedWithMe' && menu_item.icon_menu == 'mdi-share-variant' && ($route.fullPath ==='/shared-with-me/hubs' || $route.fullPath === '/shared-with-me/activities'))}"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon 
                  size="16" 
                  class="mr-2" 
                  :color="
                    (menu_item.text == 'createdByMe' && menu_item.icon_menu == 'mdi-auto-fix' && ($route.fullPath ==='/hubs' || $route.fullPath === '/activities')) || 
                    (menu_item.text == 'sharedWithMe' && menu_item.icon_menu == 'mdi-share-variant' && ($route.fullPath ==='/shared-with-me/hubs' || $route.fullPath === '/shared-with-me/activities'))
                    ? 'inherit' : 'darktext'" style="margin-bottom: 3px"
                >
                  {{menu_item.icon_menu}}
                </v-icon>
                {{ $t(menu_item.text) }}
              </v-list-item-title>
            </v-list-item-content>
         </v-list-item> -->
          <v-list-item
            router
            to="/store/overview"
            class="menu_text pl-8 pr-0 users-menu-item"
            :class="{'v-list-item--active': ($route.fullPath ==='/store/overview' || $route.fullPath === '/store/products' || $route.fullPath === '/store/orders' || $route.fullPath === '/store/customers')}"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon 
                  size="16" 
                  class="mr-2" 
                  :color="$route.fullPath ==='/store/overview' || $route.fullPath === '/store/products' || $route.fullPath === '/store/orders' || $route.fullPath === '/store/customers' ? 'inherit' : 'darktext'" 
                  style="margin-bottom: 3px"
                >
                  mdi-store
                </v-icon>
                {{ $t('storeTitle') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
       </v-list>
      </v-list>  
      <v-list class="pa-4 ">
        <v-subheader class="text-h5 font-weight-bold px-4 darktext--text">
          {{ $t('audiencesNavigationHeader') }}
        </v-subheader> 
        <v-divider />
        <v-list-item
          router
          to="/audiences/boosters"
          :class="{'v-list-item--active': $route.name ==='SpaceBoosters' || $route.name ==='SpaceUsers' || $route.name === 'SpaceInvites' || $route.name === 'SpaceGuests'}"
          class="menu_text pl-8 pr-0 users-menu-item"
        >
          <v-list-item-content>
            
            <v-list-item-title><v-icon size="16" class="mr-2" :color="$route.name ==='SpaceBoosters' || $route.name ==='SpaceUsers' || $route.name === 'SpaceInvites' || $route.name === 'SpaceGuests' ? 'inherit' : 'darktext'" style="margin-bottom: 3px">mdi-account-multiple</v-icon>  {{ $t('peopleTitle') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="hasTargetGroups"
          router
          to="/target-groups"
          :class="{'v-list-item--active': $route.name ==='TargetGroups' || $route.name === 'ViewTargetGroup' || $route.name === 'BoostersInTargetGroup'}"
          class="menu_text pl-8 pr-0 taget-groups-menu-item"
        >
          <v-list-item-content>
            
            <v-list-item-title><v-icon size="16" class="mr-2" :color="$route.name ==='TargetGroups' || $route.name === 'ViewTargetGroup' || $route.name === 'BoostersInTargetGroup' ? 'inherit' : 'darktext'" style="margin-bottom: 3px">mdi-account-group</v-icon>  {{ $t('targetGroupsTitle') }}
              <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="px-2" x-small color="accent" style="position: relative;" text-color="white">PRO</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list> 
      <v-list
        v-if="role == 'space_admin'"
        class="pa-4"
      >
        <v-subheader class="text-h5 font-weight-bold px-4 darktext--text">
          {{ $t('spacesNavigationHeader') }}
        </v-subheader> 
        <v-divider />
        <!--<v-list-item
          v-for="menu_item in filteredSpaceItems"
          :key="menu_item.text"
          router
          :to="menu_item.route"
          color="anchor"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t(menu_item.text) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
        <v-list-item
          router
          to="/space/settings"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title><v-icon size="16" class="mr-2" :color="$route.fullPath ==='/space/settings' ? 'inherit' : 'darktext'" style="margin-bottom: 3px">mdi-cog</v-icon> {{ $t('settingsSpace') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          router
          to="/space/subscription"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title><v-icon size="16" class="mr-2" :color="$route.fullPath ==='/space/subscription' ? 'inherit' : 'darktext'" style="margin-bottom: 3px">mdi-cursor-default-click</v-icon> {{ $t('settingsSubscription') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          router
          to="/space/connections"
          class="menu_text pl-8 pr-0"
          :class="{'v-list-item--active': $route.name ==='SpaceAPI' || $route.name === 'SpaceSAML' || $route.name === 'SpacePlandaySettings' || $route.name === 'SpaceEduAdminSettings'}"
        >
          <v-list-item-content>
            <v-list-item-title><v-icon size="16" class="mr-2" :color="$route.name ==='SpaceAPI' || $route.name === 'SpaceSAML' || $route.name === 'SpacePlandaySettings' || $route.name === 'SpaceEduAdminSettings' ? 'inherit' : 'darktext'" style="margin-bottom: 3px">mdi-transit-connection-variant</v-icon> {{ $t('settingsConnections') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <!-- <v-list-item
          v-if="productPlan.attributes && productPlan.attributes.public_api == 1"
          router
          to="/space/api"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t('settingsAPI') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="productPlan.attributes && productPlan.attributes.sso == 1"
          router
          to="/space/saml"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t('settingsSAML') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="productPlan.attributes && productPlan.attributes.planday_integration == 1"
          router
          to="/space/planday-users"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t('settingsPlanday') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="productPlan.attributes && productPlan.attributes.eduadmin_integration == 1"
          router
          to="/space/eduadmin-settings"
          class="menu_text pl-8 pr-0"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t('settingsEduAdmin') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
    
    <ConfirmationDialogCreateActivity 
      v-if="dialogVisibleCreateActivity"
      :visible="dialogVisibleCreateActivity" 
      data-testid="create-activity" 
      @close="dialogVisibleCreateActivity = false"
      @proceedSubmit="createActivityMsg"
    />

    <CreateWorkflowTypeDialog 
      v-if="dialogVisibleSelectWorkflowType"
      ref="confirmationDialogWorkflowType"
      :visible="dialogVisibleSelectWorkflowType" 
      :action="action" 
      data-testid="select-workflow-type-dialog" 
      @close="dialogVisibleSelectWorkflowType = false"
      @proceedSubmit="showWorkflowTitleDialog"
    />

    <ConfirmationDialogWithInputField 
      v-if="dialogVisibleWorkflow" 
      :visible="dialogVisibleWorkflow"
      :cd-title="confirmationDialogTitleWithInputField"
      :cd-text="confirmationDialogTextWithInputField"
      :cd-input-placeholder="confirmationDialogInputPlaceholder"
      :cd-submit-btn="confirmationDialogWithInputFieldSubmitBtn"
      :cd-cancel-btn="confirmationDialogWithInputFieldCancelBtn"
      data-testid="dialog-workflow"
      @close="dialogVisibleWorkflow = false, selectedItem = {}" 
      @proceedSubmit="saveWorkflow"
      :action="action" />


  </div>
</template>
<script>

import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import i18n from '../plugins/i18n'
import { createWorkflow} from '../api/workflowApi'
import CreateWorkflowTypeDialog from "./CreateWorkflowTypeDialog";
import ConfirmationDialogCreateActivity from './ConfirmationDialogCreateActivity';
import ConfirmationDialogWithInputField from './ConfirmationDialogWithInputField'

export default {
    components: {
      ConfirmationDialogCreateActivity,
      ConfirmationDialogWithInputField,
      CreateWorkflowTypeDialog,
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            drawer: null,
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
            hasTargetGroups: localStorage.space ? JSON.parse(localStorage.space).has_target_groups : false,
            // menu_items_activities: [
            //     { icon: 'mdi-eye', icon_menu:'mdi-auto-fix', text: 'createdByMe', route: '/activities'},
            //     { icon: 'mdi-eye-off',icon_menu:'mdi-share-variant', text: 'sharedWithMe', route: '/shared-with-me/activities'},

            // ],
            /*menu_items_spaces: [
                { icon: 'mdi-view-dashboard', text: 'settingsSpace', route: '/space/settings', role: ['space_admin', 'booster'], hideForFreePlan: false, hideIfNotEnabledSAML: false},
                { icon: 'mdi-view-dashboard', text: 'settingsSubscription', route: '/space/subscription', role: ['space_admin'], hideForFreePlan: false, hideIfNotEnabledSAML: false},
                { icon: 'mdi-view-dashboard', text: 'settingsAPI', route: '/space/api', role: ['space_admin'], hideForFreePlan: true, hideIfNotEnabledSAML: false},
                { icon: 'mdi-view-dashboard', text: 'settingsSAML', route: '/space/saml', role: ['space_admin'], hideForFreePlan: true, hideIfNotEnabledSAML: true},
                
            ]*/
           
            dialogVisibleCreateActivity:false,

            workflowType: 'participant',
            dialogVisibleWorkflow: false,
            dialogVisibleSelectWorkflowType: false,
            action: "",
            confirmationDialogTitleWithInputField: "",
            confirmationDialogTextWithInputField: "",
            confirmationDialogWithInputFieldCancelBtn: "",
            confirmationDialogWithInputFieldSubmitBtn: "",
            confirmationDialogInputPlaceholder: "",
            spaceId: window.$cookies.get('space_id'),
        }
    },
    computed:{
        /*filteredSpaceItems() {
            return this.menu_items_spaces.filter((item) =>{
                return item.role.includes(this.role) && ( item.hideForFreePlan == false || (item.hideForFreePlan == true && this.productPlan.attributes.name != 2) || (item.hideIfNotEnabledSAML== true && this.productPlan.attributes.sso == 1))
            });
        },*/
        productPlan() {
            return this.$store.state.productPlan;
        },
    },
    methods:{
        createActivityMsg(msg, type){
          this.alertType= type
          this.alertMsg = msg
          this.alertValue = true
          this.dialogVisibleCreateActivity = false
        },
        createHub(){
          this.$router.push({path: '/hub/create'})
        },
        createUser(){
          this.$router.push({path: '/audiences/invite'})
        },
        showWorkflowTitleDialog(event) {
          this.workflowType = event.type,
          this.dialogVisibleSelectWorkflowType = false, 
          this.dialogVisibleWorkflow = true   
        },
       
        async saveWorkflow(title) {
          this.dialogVisibleWorkflow = true
          try {
            let data = {
              data: {
                type: "workflows",
                attributes: {
                  title: title.trim(),
                  member_type: this.workflowType.trim(),
                },
                relationships: {
                  space: {
                    data: {
                      type: "spaces",
                      id: this.spaceId
                    }
                  }
                }

              }
            };
            var response = await createWorkflow(data);
            if (response) {
              if (response.status == 201) {
                this.dialogVisibleSelectWorkflowType = false, 
                this.dialogVisibleWorkflow = false;
                this.$router.push({ path: '/workflow/' + response.data.data.id })
              }
            }
          } catch (e) {
            if (e.response) {
              this.alertValue = true
              this.alertType = 'error'
              if (e.response.status == 422) {
                for (let i = 0; i < e.response.data.errors.length; i++) {
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = e.response.data.errors[i].detail;
                }
              } else if (e.response.status == 403) {
                this.$router.push({ name: 'PageAccessDenied' })
              } else {
                this.alertMsg = i18n.t('serverError')
              }
            } else {
              this.alertType = 'error'
              this.alertValue = true
              this.alertMsg = i18n.t('serverError')
            }
          }

        },

        updateDrawerState(){
          if(this.mobile()){
              this.drawer = !this.drawer
          }else{
              this.drawer = !this.drawer
          }   
        },
    }
}
</script>